import {createActionGroup, emptyProps, props} from '@ngrx/store';
import {OrderModel} from "../../models/order.model";
import {OmsOrdersQueryModel} from "../../models/oms-orders-query.model";

export const OrdersChannelActions = createActionGroup({
  source: '[Orders/Channel]',
  events: {
    subscribe: emptyProps(),
    subscribePartial: emptyProps(),
    unsubscribe: emptyProps(),
    unsubscribeSuccess: emptyProps(),
    notificationReceived: props<{ notification: OrderModel }>(),
    partialNotificationReceived: props<{ notification: OrderModel }>(),
  }
});

export const OrdersAPiActions = createActionGroup({
  source: '[Orders/API]',
  events: {

    //Get infinite scroll orders
    getInfiniteScrollOrders: props<{ query: OmsOrdersQueryModel, isSubscribeToChannel?: boolean }>(),
    getInfiniteScrollOrdersSuccess: props<{ orders: OrderModel[], nextPage: number, isSubscribeToChannel?: boolean }>(),
    getInfiniteScrollOrdersFailure: props<{ error: any }>(),

    //Get orders
    getOrders: props<{ query: OmsOrdersQueryModel, isSubscribeToChannel?: boolean }>(),
    getOrdersSuccess: props<{ orders: OrderModel[], isSubscribeToChannel?: boolean }>(),
    getOrdersFailure: props<{ error: any }>(),

    //Get Order
    getOrder: props<{ orderId: string, isSubscribeToChannel?: boolean }>(),
    getOrderSuccess: props<{ order: OrderModel, isSubscribeToChannel?: boolean }>(),
    getOrderFailure: props<{ error: any }>()

  },
});

export const OrdersActions = createActionGroup({
  source: '[Orders]',
  events: {
    removeOrders: props<{ ids: string[] }>(),
    removeOrder: props<{ id: string }>(),
    setOrders: props<{ orders: OrderModel[], isAppendFirst?: boolean }>(),
    setInfiniteScrollOrdersIds: props<{ orderIds: string[], isAppendFirst?: boolean }>(),
    removeAll: emptyProps(),
    clearStore: emptyProps()
  }
});

